

























import { defineComponent } from '@nuxtjs/composition-api';
import UCButton from '@shared/components/@atoms/UCButton/UCButton.vue';
import UCIcon from '@shared/components/@atoms/UCIcon/UCIcon.vue';
import clickOutside from 'vue-click-outside';

export default defineComponent({
  name: 'UCAppHeaderItem',
  components: { UCIcon, UCButton },
  directives: {
    clickOutside,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    columnOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('on-click');
    },
    onClickOutside() {
      this.$emit('on-click-outside');
    },
  },
});
